import { render, staticRenderFns } from "./BaseButtonSmallOrange.vue?vue&type=template&id=eeddaee2&scoped=true&"
import script from "./BaseButtonSmallOrange.vue?vue&type=script&lang=js&"
export * from "./BaseButtonSmallOrange.vue?vue&type=script&lang=js&"
import style0 from "./BaseButtonSmallOrange.vue?vue&type=style&index=0&id=eeddaee2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eeddaee2",
  null
  
)

export default component.exports